import Vue from 'vue'
import VueRouter from 'vue-router'
					




Vue.use(VueRouter)

const routes = [{
    path: "*",
    component: () => import( /* webpackChunkName: "about" */ '../views/index/index.vue')
  },

  
  {
    path: '/',
    name: 'index',
    component: () => import( /* webpackChunkName: "about" */ '../views/index/index.vue')
  },
  {
    path: '/home',
    name: 'index',
    component: () => import( /* webpackChunkName: "about" */ '../views/index/index_deactive1.vue')
  },
  {
    path: '/home2',
    name: 'index2',
    component: () => import( /* webpackChunkName: "about" */ '../views/index/index_deactive2.vue')
  },
  {
    path: '/home3',
    name: 'index3',
    component: () => import( /* webpackChunkName: "about" */ '../views/index/index.vue')
  },




  {
    path: '/courses',
    name: 'courses',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/courses/courses.vue')
  },


  {
    path: '/library',
    name: 'library',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/library/library.vue')
  },
  {
    path: '/library/details/:id',
    name: 'library_details',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/library/detail_library.vue')
  },



  {
    path: '/festival',
    name: 'festival',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/festival/index.vue')
  },
  {
    path: '/festival/details/:id',
    name: 'festival_details',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/festival/detail_festival.vue')
  },


  {
    path: '/research',
    name: 'research',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/research/index.vue')
  },

  {
    path: '/ziarat',
    name: 'ziarats',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/ziarat/index.vue')
  },

  {
    path: '/research/details/:id',
    name: 'research_details',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/research/detail_research.vue')
  },


  {
    path: '/about-us',
    name: 'about-us',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/aboutus/aboutus.vue')
  },

  {
    path: '/linkus',
    name: 'link-us',
    
    component: () => import( /* webpackChunkName: "about" */ '../views/linkus/linkus.vue')
  },



  {
    path: '/courses/details/:id',
    name: 'detail_courses',
    component: () => import( /* webpackChunkName: "about" */ '../views/courses/detail_courses.vue')
  },


  

  
  {
    path: '/login',
    name: 'login',
    component: () => import( /* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  {
    path: '/panel/education',
    name: 'panel_education',
    component: () => import( /* webpackChunkName: "about" */ '../views/panel/education.vue')
  },

  {
    path: '/panel/research',
    name: 'panel_research',
    component: () => import( /* webpackChunkName: "about" */ '../views/panel/research.vue')
  },
  

  {
    path: '/panel/festival',
    name: 'panel_festival',
    component: () => import( /* webpackChunkName: "about" */ '../views/panel/festival.vue')
  },
  {
    path: '/panel/festival/:id',
    name: 'panel_festival_details',
    component: () => import( /* webpackChunkName: "about" */ '../views/panel/festival_details.vue')
  },

  {
    path: '/panel/education/:id',
    name: 'panel_education_details',
    component: () => import( /* webpackChunkName: "about" */ '../views/panel/education_details.vue')
  },
  {
    path: '/panel/editinfo',
    name: 'panel_edit_informations',
    component: () => import( /* webpackChunkName: "about" */ '../views/panel/edit_informations.vue')
  },

  {
    path: '/calender/monasebat/:name',
    name: 'searchbook',
    component: () => import('../views/calender/detail.vue')
  },


  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,	
    scrollBehavior(to, from, savedPosition) {
      window.scrollTo({top: 0, left: 0});
      to;from;savedPosition;

}
})


export default router